import transaction from '@apis/transaction'
import { transact } from '@assets/icons'
import Status from '@components/status'
import Table from '@components/table'
import { RootState } from '@store/index'
import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

const Transactions = ({ user }: { user?: any }) => {
  const {
    items: transactions = [],
    totalItems,
    totalPages,
  } = useSelector((state: RootState) => state.transactions)
  const [page, setPage] = useState(1)
  const fetchTransactions = async () => {
    try {
      await transaction.list({
        state: 'transactions',
        params: {
          page,
          limit: 30,
          userId: !!user && user.id,
        },
      })
    } catch (error) {
      console.error('Error fetching transactions:', error)
    }
  }
  const column = [
    { title: 'Type', key: 'type' },
    { title: 'Amount', key: 'amount' },
    { title: 'Created Date', key: 'createdDate' },
    {
      title: 'Status',
      key: 'status',
      render: (item) => (
        <Status
          item={item}
          statuses={['Pending', 'Delivered', 'Cancelled']}
          onStatusChange={async (status) => {
            await transaction.update({
              state: 'transactions',
              id: item.id,
              data: { status },
            })
          }}
        />
      ),
    },
  ]
  const data = transactions.map((t) => ({
    id: t.id,
    type: t.type,
    amount: t.amount,
    createdDate: t.createdAt,
    status: t.status,
  }))
  // const data = [
  //   {
  //     type: 'Purchase',
  //     amount: 'Rs. 150',
  //     createdDate: '2025-07-03',
  //     status: 'Delivered',
  //   },
  // ]

  useEffect(() => {
    fetchTransactions()
  }, [page])
  return (
    <Fragment>
      <Table
        totalItems={totalItems}
        totalPages={totalPages}
        onPageChange={setPage}
        pageControlled={page}
        itemsPerPage={30}
        columns={column}
        data={data}
        searchKeys={['type', 'status']}
        text="Transactions"
        icon={transact}
      />
    </Fragment>
  )
}

export default Transactions
